export const CATEGORY_PATHS = {
    sr_match: {
        base: 'sr_event.match.tournament',
        paths: {
            1: 'tournament_category.sport.name',
            2: 'tournament_category.name',
            3: 'name',
        },
    },
    sr_tournament: {
        base: 'sr_event.tournament',
        paths: {
            1: 'tournament_category.sport.name',
            2: 'tournament_category.name',
            3: 'name',
        },
    },
    st_stage: {
        base: 'st_event.stage',
        paths: {
            1: 'stage_category.sport.name',
            2: 'stage_category.parent.name',
            3: 'stage_category.name',
        },
    },
    st_stage_category: {
        base: 'st_event.stage_category',
        paths: {
            1: 'sport.name',
            2: 'parent.name',
            3: 'name',
        },
    },
    av_event: {
        base: 'av_event',
        dynamic: true,
    },
    tournament: {
        base: 'tournament',
        paths: {
            1: 'tournament_category.sport.name',
            2: 'tournament_category.name',
            3: 'name',
        },
    },
    stage_category: {
        base: 'stage_category',
        paths: {
            1: 'sport.name',
            2: 'parent.name',
            3: 'name',
        },
    },
};
